import MainInventory from '~user-pages/Inventory/MainInventory.vue'
import InventoryManagement from '~user-pages/Inventory/Management/InventoryManagement'
import MainOrdersPage from '~user-pages/Orders/MainOrdersPage'
import MainReports from '~user-pages/Reports/MainReports'
import Profile from '~user-pages/UserSettings/Profile'
import ShippingSettings from '~user-pages/UserSettings/ShippingSettings'
import Marketplaces from '~user-pages/UserSettings/Marketplaces/Marketplaces'
import Notifications from '~user-pages/Notifications'
import OrdersRoutes from './orders-routes'
import ReportsRoutes from './reports-routes'
import InventoryRoutes from './inventory-routes.js'

export default [
    {
        path: '/user-panel',
        name: 'UserPanel',
        component: InventoryManagement
    },
    {
        path: 'inventory',
        component: MainInventory,
        redirect: {
            name: 'InventoryManagement'
        },
        meta: {
            breadcrumb: {
                text: 'Inventory'
            }
        },
        children: [
            ...InventoryRoutes
        ]
    },
    {
        path: 'orders',
        component: MainOrdersPage,
        redirect: { name: 'Orders' },
        meta: {
            breadcrumb: {
                text: 'Orders'
            }
        },
        children: [
            ...OrdersRoutes
        ]
    },
    {
        path: 'reports',
        redirect: {name: 'Payments'},
        component: MainReports,
        meta: {
            breadcrumb: {
                text: 'Reports'
            }
        },
        children: [
            ...ReportsRoutes
        ]
    },
    {
        path: 'my-profile',
        name: 'Profile',
        component: Profile,
        meta: {
            breadcrumb: {
                text: 'Profile'
            }
        }
    },
    {
        path: 'shipping-settings',
        name: 'ShippingSettings',
        component: ShippingSettings,
        meta: {
            breadcrumb: {
                text: 'Shipping Settings'
            }
        }
    },
    // {
    //     path: 'shipping-settings-demo',
    //     name: 'ShippingSettingsDemo',
    //     component: ShippingSettings,
    //     meta: {
    //         breadcrumb: {
    //             text: 'Shipping Settings'
    //         }
    //     }
    // },
    {
        path: 'shipping-settings/shipping-policy/add-products',
        name: 'ShippingPolicyAddProduct',
        component: () => import('~cp/UserPanel/Elements/ShippingPolicySettings/components/AddProducts.vue')
    },
    {
        path: 'link-e-shops',
        name: 'Marketplaces',
        component: Marketplaces,
        meta: {
            breadcrumb: {
                text: 'Link E-shops'
            }
        }
    },
    {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications,
        meta: {
            breadcrumb: {
                text: 'Messages/Notifications'
            }
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/modules/user-panel-routes.js